import React from "react";
import { getString } from "../../utilities";
// import NoSymbol from "../../../assets/svg/noSymbol.svg";
import Lock from "../../../assets/svg/unlockColor.svg";
import Devices from "../../../assets/svg/devices.svg";
import SubscriptionCard from "./subscriptionCard";
import PlansPromoDescription from "../global/plansPromoDescription";
import PlansPromoDisclaimer from "../global/plansPromoDisclaimer";

export default function FamilyPlans({ plan, setPlan, planAmount, setPlanAmount, planData, promo = null, setPromo }) {
  return (
    <div className="wrapper plans-wrapper family">
      <div className="plans-title">{getString("subscribe.plans.family.title.1")}</div>

      <PlansPromoDescription promo={promo} pRole="family" />

      <ul className="plans-perks">
        {/* Temporally remove ad-related text. May become permanent later. */}
        {/* <li>
          <NoSymbol className="icon" />
          {getString("subscribe.plans.family.perks.0")}
        </li> */}
        <li>
          <Lock className="icon" />
          {getString("subscribe.plans.family.perks.1")}
        </li>
        <li>
          <Devices className="icon" />
          {getString("subscribe.plans.family.perks.2")}
        </li>
      </ul>

      <div className="plans-subs">
        <SubscriptionCard
          setPlan={setPlan}
          planAmount={planAmount}
          setPlanAmount={setPlanAmount}
          planData={planData}
          plan={plan}
          subscription="m1"
        />
        <SubscriptionCard
          setPlan={setPlan}
          planAmount={planAmount}
          setPlanAmount={setPlanAmount}
          planData={planData}
          plan={plan}
          subscription="m6"
        />
        <SubscriptionCard
          setPlan={setPlan}
          planAmount={planAmount}
          setPlanAmount={setPlanAmount}
          planData={planData}
          plan={plan}
          subscription="m12"
          isBest={true}
        />
      </div>

      <div className="plans-disclaimer">{getString("subscribe.plans.disclaimer")}</div>

      <PlansPromoDisclaimer promo={promo} pRole="family" />
    </div>
  );
}
